import { SCHEMA_VERSION } from "./doc";

/**
 * Settings tie-break: larger serialised value wins. Arbitrary, but the same on
 * both devices, which stops two migrated devices overwriting each other for ever.
 */
function pickSetting(a, b) {
  if (!a) return b;
  if (!b) return a;
  if (a.updatedAt !== b.updatedAt) return a.updatedAt > b.updatedAt ? a : b;
  return JSON.stringify(a.value) >= JSON.stringify(b.value) ? a : b;
}

/** Tick tie-break: on wins, so an equal-timestamp clash never loses a tick. */
function pickTick(a, b) {
  if (!a) return b;
  if (!b) return a;
  if (a.updatedAt !== b.updatedAt) return a.updatedAt > b.updatedAt ? a : b;
  return a.on ? a : b;
}

const keysOf = (...objects) => [...new Set(objects.flatMap((o) => Object.keys(o || {})))];

export function merge(local, remote) {
  if (!remote || !remote.settings || !remote.ticks) return local;

  const settings = {};
  for (const key of keysOf(local.settings, remote.settings)) {
    settings[key] = pickSetting(local.settings[key], remote.settings[key]);
  }

  const ticks = {};
  for (const day of keysOf(local.ticks, remote.ticks)) {
    const mine = (local.ticks || {})[day] || {};
    const theirs = (remote.ticks || {})[day] || {};
    ticks[day] = {};
    for (const slot of keysOf(mine, theirs)) ticks[day][slot] = pickTick(mine[slot], theirs[slot]);
  }

  return { schemaVersion: SCHEMA_VERSION, settings, ticks };
}
